module.exports = __webpack_public_path__ + "static/media/Arxius.e40a8907.svg";